import { render, staticRenderFns } from "./TrainingCertificationForm.vue?vue&type=template&id=dd6edf2c&scoped=true&"
import script from "./TrainingCertificationForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCertificationForm.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCertificationForm.vue?vue&type=style&index=0&id=dd6edf2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6edf2c",
  null
  
)

export default component.exports